export const WARNING = 'warning';
export const DANGER = 'danger';
export const SUCCESS = 'success';
